

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface PackageControllerParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface PackageController {
    id?: string;
    name: string;
    price?:number;
  parameters?: PackageControllerParameter[];
  links?: any;
}

export abstract class PackageControllerData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(): Observable<PackageController[]>;
  abstract create(url: string,data: PackageController): Observable<any>;
  abstract update(url: string,data: PackageController): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
